import {isTruthy} from "@khanacademy/wonder-stuff-core";

import type {ServerPost} from "../types.ts";

export const filterFeedback = (feedback: any): ServerPost => {
    const {
        __typename: _,
        feedbackType,
        author,
        replyCount,
        answerCount,
        focus,
        answers,
        ...filteredMessage
    } = feedback;

    const reduxType = feedbackType ? feedbackType.toLowerCase() : "";

    const post = {
        ...filteredMessage,
        type: reduxType,
        authorAvatarName: author?.avatar?.name || "",
        authorAvatarSrc: author?.avatar?.imageSrc || "",
        authorKaid: author?.kaid || "",
        authorNickname: author?.nickname || "",
        replyCount: replyCount || 0,
        answerCount: answerCount || 0,
        focus: focus,
        replies: [],
        feedbackType,
    } as const;
    if (answers) {
        const filteredAnswers = answers ? filterFeedbackList(answers) : [];
        post.answers = filteredAnswers;
    }
    return post;
};

export const filterFeedbackList = (feedback: Array<any>): Array<ServerPost> => {
    return feedback.filter(isTruthy).map(filterFeedback);
};
